<template>
  <div>
    <el-form :model="searchForm" :rules="rules" class="search-form" ref="formGroupRef">
      <el-form-item label="用券用户手机号" prop="thirdBuyer">
        <el-input
          :maxlength="255"
          v-model="searchForm.thirdBuyer"
          placeholder="用券用户手机号"
        />
      </el-form-item>
      <el-form-item label="团购券名称" prop="couponName">
        <el-input
          :maxlength="255"
          v-model="searchForm.couponName"
          placeholder="请输入团购券名称"
        />
      </el-form-item>

      <el-form-item label="领券日期" prop="createTime">
        <el-date-picker
          v-model="searchForm.createTime"
          type="daterange"
          range-separator="-"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          format="yyyy-MM-dd"
          value-format="yyyy-MM-dd"
          @change="changeCreateTime"
          :clearable="false"
          :picker-options="pickerOptions('createTime')"
          @blur="blur('createTime')"
        >
        </el-date-picker>
      </el-form-item>

      <el-form-item label="团购券状态">
        <el-select v-model="searchForm.status" placeholder="请选择团购券状态">
          <el-option
            v-for="item in statusList"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          />
        </el-select>
      </el-form-item>

      <el-form-item label="快手团购订单号" prop="thirdOrderId">
        <el-input
          :maxlength="255"
          v-model="searchForm.thirdOrderId"
          placeholder="请输入用券订单号"
        />
      </el-form-item>
      <el-form-item label="所属店铺" prop="shopId">
        <el-select v-model="searchForm.searchShopIdStr" placeholder="请选择店铺" style="width:300px;">
          <el-option v-for="(item,index) in shopIdList" :key="index" :label="item.shopName" :value="item.shopId"></el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="用券订单号" prop="orderId">
        <el-input
          :maxlength="255"
          v-model="searchForm.orderId"
          placeholder="请输入用券订单号"
        />
      </el-form-item>

      <el-form-item label="核销券码" prop="code">
        <el-input
          :maxlength="255"
          v-model="searchForm.code"
          placeholder="请输入核销券码"
        />
      </el-form-item>

      <el-form-item label="用券日期" prop="useTime">
        <el-date-picker
          v-model="searchForm.useTime"
          type="daterange"
          range-separator="-"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          format="yyyy-MM-dd"
          value-format="yyyy-MM-dd"
          @change="changeUseTime"
          :clearable="false"
          :picker-options="pickerOptions('useTime')"
          @blur="blur('useTime')"
        >
        </el-date-picker>
      </el-form-item>

      <el-form-item label="券退款状态">
        <el-select v-model="searchForm.refundStatus" placeholder="请选择团购券状态">
          <el-option
            v-for="item in refundStatusList"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          />
        </el-select>
      </el-form-item>

      <el-form-item>
        <!-- 操作按钮 -->
        <el-button type="warning" @click="onFormSearch">查询</el-button>
        <el-button type="warning" plain @click="onFormReset">重置</el-button>
        <el-button :loading="exportLoading" @click="onFormExport">导出数据</el-button>
      </el-form-item>
    </el-form>
    <el-table
      ref="table"
      header-row-class-name="header"
      border
      highlight-current-row
      :data="table.dataSource"
      v-loading="table.loading"
    >
      <el-table-column label="用券用户手机号" min-width="140" prop="thirdBuyer">
      </el-table-column>
      <el-table-column label="领券时间" min-width="165" prop="createTimeStr">
      </el-table-column>
      <el-table-column label="团购券名称" min-width="140" prop="couponName">
      </el-table-column>
      <el-table-column label="团购券面值（元）" min-width="140" prop="cheaperPriceBd">
      </el-table-column>
      <el-table-column label="核销券码" min-width="160" prop="code"> </el-table-column>
      <el-table-column label="快手团购订单号" min-width="200" prop="thirdOrderId"> </el-table-column>
      <el-table-column label="团购券支付价（元）" min-width="160" prop="payAmountBd">
      </el-table-column>
      <el-table-column label="所属店铺" min-width="160" prop="shopName"></el-table-column>
      <el-table-column label="快手平台补贴" min-width="140" prop="platformDiscountAmountBd">
      </el-table-column>
      <el-table-column label="券使用状态" min-width="100" prop="statusStr">
      </el-table-column>
      <el-table-column label="券退款状态" min-width="100" prop="refundStatusStr">
      </el-table-column>
      <el-table-column label="用券影票订单号" min-width="200" prop="orderId">
        <template slot-scope="{row}">
          <orderIdDetail :is-order="true" :row="row"></orderIdDetail>
        </template>
      </el-table-column>
      <el-table-column label="市场价（元）" min-width="120" prop="initPriceBd">
      </el-table-column>
      <el-table-column label="虚拟加价" min-width="120" prop="virtualAddPrice">
      </el-table-column>
      <el-table-column label="券后支付价（元）" min-width="140" prop="couponPayPriceBd">
      </el-table-column>

      <el-table-column label="指导价（元）" min-width="120" prop="guidePriceBd">
      </el-table-column>
      <el-table-column label="快手侧达人ID" min-width="200" prop="settledCommission">
        <template slot-scope="{ row }">
          <div>达人快手ID：{{ row.darenId || "-" }}</div>
          <div v-if="ksGroupOrderLogicShow">达人极光ID：{{ row.reference || "-" }}</div>
        </template>
      </el-table-column>

      <el-table-column
        label="快手侧达人佣金（元）"
        min-width="160"
        prop="darenCommissionBd"
      >
      </el-table-column>
      <el-table-column label="用券时间" min-width="165" prop="useTimeStr">
      </el-table-column>
    </el-table>
    <!-- 分页-->
    <el-pagination
      v-if="table.total"
      class="table-pagination"
      @size-change="onSizeChange"
      @current-change="onCurrentChange"
      :current-page.sync="pagination.pageNo"
      :page-sizes="[10, 20, 30, 40]"
      :page-size="pagination.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="table.total"
    >
    </el-pagination>

  </div>
</template>

<script>
import mini from "@/api/mini";
const MiniModel = new mini();
import debounce from "@/utils/debounce.js";
import orderIdDetail from "./component/orderId-detail.vue";
import OrderDetail from "../groupOrder/OrderDetail.vue";
const searchParams = {
  thirdBuyer: "", // 用券用户
  couponName: "", // 团购券名称
  orderId: "", //用券订单号
  useTimeStart: "",
  useTimeEnd: "",
  useTime: [], //用券时间
  status: "", //团购券状态
  code: "", // 核销券码
  createTime: [], // 领券时间
  createTimeStart: "",
  createTimeEnd: "",
  thirdOrderId: "", // 快手团购订单号
  refundStatus: "", // 券退款状态
  searchShopIdStr:'',
};
export default {
  components:{
    OrderDetail,
    orderIdDetail
  },
  props: {
    activeName: {
      // 激活名称
      type: String,
    },
  },
  data() {
    return {
      couponPlatformType:'30',
      // pickerOptions: {
      //   disabledDate(time) {
      //     const curDate = new Date().getTime();
      //     const minTime = curDate - 89 * 24 * 3600 * 1000; // 90天
      //     const maxTime = curDate; // 昨天
      //     return time.getTime() > maxTime || time.getTime() < minTime;
      //   },
      // },
      // pickerOptions1: {
      //   disabledDate(time) {
      //     return time.getTime() > Date.now();
      //   },
      // },
      ksGroupOrderLogicShow: false,
      exportLoading: false, // 导出loading
      searchForm: Object.assign({}, searchParams),
      pagination: {
        // 分页
        pageSize: 10, // 表格分页页数
        pageNo: 1, // 表格当前页数
      },
      table: {
        selectRowsIds: [], // 选中数据
        // 表格
        dataSource: [], // 表格数据
        total: 0, // 总数
        loading: false, // 表格加载loading
      },
      statusList: [
        {
          label: "全部",
          value: "",
        },
        {
          label: "待使用",
          value: 0,
        },
        {
          label: "已使用",
          value: 1,
        },
        {
          label: "已核销",
          value: 2,
        },
        // {
        //   label: "已退款",
        //   value: 3,
        // },
      ],
      refundStatusList: [
        {
          label: "全部",
          value: "",
        },
        {
          label: "已退款",
          value: 1,
        },
        {
          label: "撤销核销失败",
          value: 2,
        },
      ],
      rules:{
        thirdOrderId: [
          { validator: this.validateNumber, trigger: 'blur' } // 自定义校验规则
        ]
      },
      shopIdList:[],
      pickerStateMap:{}
    };
  },
  watch: {
  activeName: {
      immediate: true,
      handler(val) {
        if (val === "usage") {
          this.searchForm.createTime = [
            new Date(new Date().getTime() - 6 * 24 * 60 * 60 * 1000),
            new Date(),
          ];
          // createTime日期格式转换为年月日
          this.searchForm.createTime = this.searchForm.createTime.map((item) =>
            this.formatDateHandel(item)
          );
          this.searchForm.createTimeStart = this.searchForm.createTime[0];
          this.searchForm.createTimeEnd = this.searchForm.createTime[1];

          // this.searchForm.useTime = [
          //   new Date(new Date().getTime() - 6 * 24 * 60 * 60 * 1000),
          //   new Date(),
          // ];
          // // createTime日期格式转换为年月日
          // this.searchForm.useTime = this.searchForm.useTime.map((item) =>
          //   this.formatDateHandel(item)
          // );
          // this.searchForm.useTimeStart = this.searchForm.useTime[0];
          // this.searchForm.useTimeEnd = this.searchForm.useTime[1];

          this.freshTable();
          this.getksGroupOrderLogicShow();
          this.getDyDdCouponQueryShop()
        }
      },
    },
  },
  computed: {
    // ...mapState('user', ['isHoliday'])
    isHoliday() {
      return this.$store.getters.isHoliday
    },
  },
  methods: {
    // 限制时间范围
    pickerOptions(key) {
      if (!this.pickerStateMap[key]) {
        this.$set(this.pickerStateMap, key, {
          tempStartDate: null,
        })
      }
      return {
        onPick: ({minDate, maxDate}) => {
          if(!this.isHoliday) return
          // console.log(minDate, maxDate,'onPickonPick')
          const state = this.pickerStateMap[key]
          // 只选了第一个时间
          if (minDate && !maxDate) {
            state.tempStartDate = minDate
          }
          // 选完 or 清空
          if (!minDate && !maxDate) {
            state.tempStartDate = null
          }
        },
        disabledDate: (time) => {
          if(!this.isHoliday) return
          // console.log(time,'disabledDatedisabledDate',this.isHoliday)
          const state = this.pickerStateMap[key]
          if (!state.tempStartDate) {
            return false
          }
          const day = 30
          const sixMonth = day * 24 * 3600 * 1000
          const startTime = state.tempStartDate.getTime()

          return (
            time.getTime() <= startTime - sixMonth ||
            time.getTime() >= startTime + sixMonth
          )
        }
      }
    },
    blur(key) {
      console.log(key,'blur==',this.isHoliday)
      // this.tempStartDate = null
      this.pickerStateMap[key].tempStartDate = null
    },
    async getDyDdCouponQueryShop() {
      let appKeyMini = localStorage.getItem("appKeyMini");
      const res = await MiniModel.dyDdCouponQueryShopV3({
        miniAppKey:appKeyMini
      })
      console.log(res,'抖音查询商铺信息')
      if(res.data.code === 200) {
        this.shopIdList = [
          {
            shopId:'',
            shopName:'全部',
          },
          ...res.data.data,
        ]
      }else{
        this.$message.error(res.data.message)
      }
    },
    // 自定义的数字校验规则
    validateNumber(rule, value, callback) {
      if (value === '') {
        // 如果值为空，不做任何校验
        callback();
      } else if (!/^\d+$/.test(value)) {
        // 如果值不为空，并且不是数字，报错
        callback(new Error('请输入数字'));
      } else {
        // 如果值是数字，校验通过
        callback();
      }
    },
    handelOrderIdDetail(row) {
      console.log(row,'rows')
      this.$refs.orderIdDetailRef.openDialog(row)
    },
    formatDateHandel(date) {
      var year = date.getYear() + 1900; // getYear返回的是从1900年开始算起的年份，需加上1900
      var month = date.getMonth() + 1; // getMonth返回的是0-11，需要加1
      var day = date.getDate();

      // 格式化为yyyy-mm-dd格式
      var formattedDate =
        year +
        "-" +
        (month < 10 ? "0" + month : month) +
        "-" +
        (day < 10 ? "0" + day : day);
      return formattedDate;
    },
    // 修改下单时间
    changeCreateTime(arr) {
      if (arr && arr.length) {
        this.searchForm.createTimeStart = arr[0];
        this.searchForm.createTimeEnd = arr[1];
      } else {
        this.searchForm.createTimeStart = "";
        this.searchForm.createTimeEnd = "";
      }
    },
    // 修改用券时间
    changeUseTime(arr) {
      if (arr && arr.length) {
        this.searchForm.useTimeStart = arr[0];
        this.searchForm.useTimeEnd = arr[1];
      } else {
        this.searchForm.useTimeStart = "";
        this.searchForm.useTimeEnd = "";
      }
    },
    // 是否有团购券权限
    async getksGroupOrderLogicShow() {
      const res = await MiniModel.getConfigGet({ name: "ksGroupOrderLogicShow" });
      this.ksGroupOrderLogicShow = res.data.code === 200 && res.data.data === "1";
    },
    // 表单搜素
    onFormSearch() {
      debounce(
        () => {
          this.$refs['formGroupRef'].validate((valid) => {
            if (valid) {
              this.pagination.pageNo = 1;
              this.freshTable();
            } else {
              console.log('error submit!!');
              return false;
            }
          });
        },
        500,
        true
      );
    },
    // 表单重置
    onFormReset() {
      debounce(
        () => {
          this.searchForm = Object.assign({}, searchParams);

          this.searchForm.createTime = [
            new Date(new Date().getTime() - 6 * 24 * 60 * 60 * 1000),
            new Date(),
          ];
          // createTime日期格式转换为年月日
          this.searchForm.createTime = this.searchForm.createTime.map((item) =>
            this.formatDateHandel(item)
          );
          this.searchForm.createTimeStart = this.searchForm.createTime[0];
          this.searchForm.createTimeEnd = this.searchForm.createTime[1];

          this.pagination.pageSize = 10;
          this.pagination.pageNo = 1;
          this.freshTable();
        },
        500,
        true
      );
    },
    // 分页数据变化
    onSizeChange(val) {
      this.pagination.pageSize = val;
      this.freshTable();
    },
    // 分页跳转
    onCurrentChange() {
      this.freshTable();
    },
    // 请求表格·
    async freshTable() {
      this.table.loading = true;

      const parmas = {
        // appKey: localStorage.getItem("appKeyMini"),
        miniAppKey: localStorage.getItem("appKeyMini"),
        ...this.searchForm,
        ...this.pagination,
        useTimeStart:
          this.searchForm.useTimeStart && this.searchForm.useTimeStart.length
            ? `${this.searchForm.useTimeStart} 00:00:00`
            : "",
        useTimeEnd:
          this.searchForm.useTimeEnd && this.searchForm.useTimeEnd.length
            ? `${this.searchForm.useTimeEnd} 23:59:59`
            : "",
        createTimeStart:
          this.searchForm.createTimeStart && this.searchForm.createTimeStart.length
            ? `${this.searchForm.createTimeStart} 00:00:00`
            : "",
        createTimeEnd:
          this.searchForm.createTimeEnd && this.searchForm.createTimeEnd.length
            ? `${this.searchForm.createTimeEnd} 23:59:59`
            : "",
        couponPlatformType: this.couponPlatformType,
      };
      delete parmas.useTime;

      delete parmas.createTime;
      const data = await MiniModel.couponSearchMarket(parmas).finally(() => {
        this.table.loading = false;
      });
      if (data.data.code === 200) {
        this.table.dataSource = data.data.data.list;
        this.table.total = data.data.data.total;
      }
    },
    formatDate(date) {
      var y = date.getFullYear();
      var m = date.getMonth() + 1;
      m = m < 10 ? "0" + m : m;
      var d = date.getDate();
      d = d < 10 ? "0" + d : d;
      return y + m + d;
    },
    onFormExport() {
      this.exportLoading = true;
      const parmas = {
        // appKey: localStorage.getItem("appKeyMini"),
        miniAppKey: localStorage.getItem("appKeyMini"),
        ...this.searchForm,
        useTimeStart:
          this.searchForm.useTimeStart && this.searchForm.useTimeStart.length
            ? `${this.searchForm.useTimeStart} 00:00:00`
            : "",
        useTimeEnd:
          this.searchForm.useTimeEnd && this.searchForm.useTimeEnd.length
            ? `${this.searchForm.useTimeEnd} 23:59:59`
            : "",
        createTimeStart:
          this.searchForm.createTimeStart && this.searchForm.createTimeStart.length
            ? `${this.searchForm.createTimeStart} 00:00:00`
            : "",
        createTimeEnd:
          this.searchForm.createTimeEnd && this.searchForm.createTimeEnd.length
            ? `${this.searchForm.createTimeEnd} 23:59:59`
            : "",
        couponPlatformType: this.couponPlatformType,
      };
      console.log(parmas, "parmasparmasparmasparmas");
      delete parmas.useTime;

      delete parmas.createTime;
      MiniModel.couponExportV3Market(parmas)
        .then(async(res) => {
          console.log(res,'res===============111')
          const code = res.data.code
          const message = res.data.message
          if (code === 200) {
            await this.$alert(`当前数据下载中，请前往 导出中心 查看`, '导出数据提示', {
              showCancelButton: true,
              confirmButtonText: '前往导出列表',
              cancelButtonText: '取消',
              callback: action => {
                if(action === 'confirm'){
                  this.$router.push({ path: "/pc/exportCenter/index" });
                }
                this.exportLoading = false
              }
            });
          } else {
            this.$Message.error(message)
          }
        })
        .catch(() => {
          this.exportLoading = false;
        }).finally(()=>{
        this.exportLoading = false
      })
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/pc/miniProgram/couponGroupNew/KsCouponGroup.vue